import { ElementHTML } from '@helpers/helper.rendering'
import React, { useState, useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'
import $ from 'jquery'

const Separator_1 = ({
  titleElement,
  title,
  titleColor,
  titleHexa,
  paragraphs,
  paragraphElement,
  paragraphColor,
  paragraphHexa,
  backgroundColor,
  backgroundHexa,
  hidden,
  height,
  buttons,
  dateElement,
  is_short,
  parallax,
  customBorderRadius,
}: RealEstateDataPageComponentData) => {
  const [Loaded, setLoaded] = useState(false)

  useEffect(() => {
    setLoaded(true)
  }, [])

  const [half, setHalf] = useState(false)

  const [headerHeight, setHeaderHeight] = useState<any>()

  useEffect(() => {
    setTimeout(() => {
      var headerH = $('header').outerHeight()
      setHeaderHeight(headerH!)
      $('.separator-component-2').addClass('animate__fadeInDown')
    }, 1000)
    var form = document.getElementById('form-detail-float')
    if (form) {
      setHalf(true)
    }
  }, [])

  return (
    Loaded && (
      <section
        style={{
          background: backgroundHexa,
          top: headerHeight + 'px',
          height:
            screen.width < 992
              ? height?.mobile.toString() + (height?.scalePixels ? 'px' : 'vh')
              : height?.desktop.toString() + (height?.scalePixels ? 'px' : 'vh'),
        }}
        className={
          'd-lg-flex align-items-center justify-content-center separator-component-2 animate__animated ' +
          (true ? ' text-center ' : '') +
          (hidden ? ' d-none' : ' d-flex') +
          (' ' + backgroundColor) +
          (half ? ' half-container-fluid-left' : '') +
          (is_short ? ' position-fixed ' : parallax ? 'position-sticky' : '')
          // (' ' + dateElement)
        }
      >
        <Container
          fluid
          className="d-flex align-items-center justify-content-center"
        >
          {title && (
            <ElementHTML
              children={title || ''}
              elementType={titleElement || ''}
              className={titleColor + ' mb-0 ' + (paragraphs?.length ? '' : '')}
              style={{ color: titleHexa }}
            />
          )}
          {paragraphs?.map((paragraph) => (
            <ElementHTML
              children={paragraph}
              elementType={paragraphElement || 'p'}
              className={paragraphColor + ' mx-2 mb-0'}
              style={{ color: paragraphHexa }}
            />
          ))}
          {buttons?.map((button) => (
            <a
              className="mx-2"
              style={{
                background: button.backgroundColor,
                color: button.valueColor,
                borderRadius: customBorderRadius + 'px',
                border: '1px solid' + button.borderColor,
              }}
              href={button.link}
            >
              {button.value}
            </a>
          ))}
        </Container>
      </section>
    )
  )
}

export default Separator_1
